import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-touchspin',
  templateUrl: './touchspin.component.html',
  styleUrls: ['./touchspin.component.less']
})
export class TouchspinComponent {
  @Input() value: number = 1;
  @Input() max: number;
  @Output() change = new EventEmitter<number>();
  triggerTimeout: number;

  constructor() {}

  public update(val: number) {
    if (val < 1 || val > this.max) return;
    this.value = val;
    this.triggerChange();
  }

  private triggerChange() {
    if (typeof window !== 'undefined') {
      window.clearTimeout(this.triggerTimeout);

      this.triggerTimeout = window.setTimeout(() => {
        this.change.emit(this.value);
      }, 1000);
    }
  }

  public increase() {
    const newVal = this.value + 1;
    return this.update(newVal);
  }

  public decrease() {
    const newVal = this.value - 1;
    return this.update(newVal);
  }
}
